import { isOptional } from '../types/utils/typeguards';
export const getIsAnyRecurring = (lineItems, selectedOptionalLineItems) => {
  return lineItems.some((lineItem, index) => {
    if (isOptional(lineItem) && selectedOptionalLineItems && !selectedOptionalLineItems[index]) {
      return false;
    }
    return lineItem.recurringBillingTerms;
  });
};